import React from 'react';
import { useTranslation } from 'react-i18next';

import LanguageSelector from '@/shared/components/atoms/LanguageSelector';

import AydiLogoAR from '~/svg/logoARHorizontel.svg';
import AydiLogo from '~/svg/LogoHorizontelEN.svg';

function Header() {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <div className='flex w-full items-center justify-between gap-2'>
      {language === 'ar' ? (
        <AydiLogoAR
          alt='login'
          className='-my-24 text-[5rem] text-primary-default'
        />
      ) : (
        <AydiLogo
          alt='login'
          className='-my-24 text-[5rem] text-primary-default'
        />
      )}
      <LanguageSelector useName />
    </div>
  );
}

export default Header;
